'use client'

import React from 'react'

import FAQ from 'lib/components/FAQ/FAQ'
import FiftyFifty, { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import Link from 'lib/components/Link/Link'
import PageSection from 'lib/components/PageSection/PageSection'
import Spacer from 'lib/components/Spacer/Spacer'
import Steps from 'lib/components/Steps/Steps'

import NarrativePage from '@/components/NarrativePage'
import { ShipGoWelcomeModal } from '@/components/shipplay/ShipGoWelcomeModal'
import { brand } from '@/utils/brand'

import ShipplayHowItWorksPage from './ShipplayHowItWorksPage'

// Information Cards Component
const InformationCards: React.FC = () => {
  const { informationCards: cards } = brand.pageContent.HowItWorks

  return (
    <div className="mx-auto max-w-7xl">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {cards.map((card, index) => (
          <div key={index} className="rounded-lg border border-gray-100 bg-white p-6 shadow-sm">
            <h3 className="mb-3 text-xl font-bold text-gray-900">{card.title}</h3>
            <p className="mb-4 leading-relaxed text-gray-700">{card.description}</p>
            <Link
              href={card.link}
              className="font-medium text-gray-900 transition-colors hover:text-blue-600"
              underline={false}
              inline
            >
              Continue reading
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

const HowItWorksPage: React.FC = () => {
  // Ship&Play brand uses the ported playground layout (Hero + HowItWorksSteps
  // + CustomerResources + FAQ). See ShipplayHowItWorksPage for details.
  if (brand.key === 'shipplay') {
    return (
      <>
        <ShipGoWelcomeModal />
        <ShipplayHowItWorksPage />
      </>
    )
  }

  const { faq, fifties, hero, steps } = brand.pageContent.HowItWorks

  return (
    <NarrativePage hero={hero}>
      <Spacer />
      <Steps steps={steps.steps} header={steps.header} />
      <Spacer />

      {fifties &&
        fifties.map((fifty: FiftyFiftyProps, index: number) => (
          <FiftyFifty key={index} {...fifty} />
        ))}
      <Spacer />
      <PageSection className="px-[24px] pb-12 md:px-[40px] md:pb-[64px] lg:px-[64px]">
        <InformationCards />
      </PageSection>
      <Spacer />
      <PageSection className="px-[24px] md:px-[40px] lg:px-[64px]">
        <FAQ {...faq} />
      </PageSection>
      <Spacer />
    </NarrativePage>
  )
}

export default HowItWorksPage
